module.exports = require("./hy-AM.js");